import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';

import { AppConfig } from '../config/app.config';
import { IReturnObject } from '../shared/return-object.model';
import { PackagingMaterialBE } from './shared/packaging-material.model';

@Injectable()
export class PackagingMaterialService {
    constructor(private config: AppConfig, private http: Http) { }

    private apiUrl: string = this.config.get('apiUrl') + 'PackagingMaterial';
    private adminApiUrl: string = this.config.get('apiUrl') + 'Admin';

    saveMaterial(instruction: PackagingMaterialBE): Observable<IReturnObject> {
        let headers: Headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('Accept', 'application/json');
        let body = JSON.stringify(instruction);
        let options = new RequestOptions({ headers: headers });

        return this.http.post(`${this.apiUrl}/SaveMaterial`, body, options)
            .map((response: Response) => <IReturnObject>response.json());
    }

    deleteMaterial(id: number): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/DeleteMaterial?materialId=${id}`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    searchMaterial(searchText: string): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/SearchMaterial/?searchText=${searchText}`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    getMaterial(materialId: number): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/GetMaterial/?materialId=${materialId}`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    mhnoExist(mhno: string): Observable<boolean> {
        return this.http.get(`${this.apiUrl}/MhnoExist/?mhno=${mhno}`)
            .map((response: Response) => <boolean>response.json());
    }

    getPreviewPdf(id: number, mhno: string): Observable<any> {
        return this.http.get(`${this.apiUrl}/GetPreviewPdfForMaterial/?materialId=${id}&mhno=${mhno}`);
    }

    getPackagingTypes(): Observable<IReturnObject> {
        return this.http.get(`${this.adminApiUrl}/GetPackagingTypes`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    getPackagingOwners(): Observable<IReturnObject> {
        return this.http.get(`${this.adminApiUrl}/GetPackagingOwners`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    getStorageConditions(): Observable<IReturnObject> {
        return this.http.get(`${this.adminApiUrl}/GetStorageConditions`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    getReturnables(): Observable<IReturnObject> {
        return this.http.get(`${this.adminApiUrl}/GetReturnables`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    getClassifications(): Observable<IReturnObject> {
        return this.http.get(`${this.adminApiUrl}/GetClassifications`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    getDispatcherReceiver(): Observable<IReturnObject> {
        return this.http.get(`${this.adminApiUrl}/GetDispatchers`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    getWashingSuppliers(): Observable<IReturnObject> {
        return this.http.get(`${this.adminApiUrl}/GetWashingSuppliers`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    getMainStores(): Observable<IReturnObject> {
        return this.http.get(`${this.adminApiUrl}/GetMainStores`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    getConsumingAreas(): Observable<IReturnObject> {
        return this.http.get(`${this.adminApiUrl}/GetConsumingAreas`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    getRegions(): Observable<IReturnObject> {
        return this.http.get(`${this.adminApiUrl}/GetRegions`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    getMaterialList(): Observable<IReturnObject> {
        return this.http.get(`${this.adminApiUrl}/GetMaterialList`)
            .map((response: Response) => <IReturnObject>response.json());
    }
}



// WEBPACK FOOTER //
// C:/Users/PBABH7/Workspace/OnPremChina/PackITWebGui/src/app/packaging-material/packaging-material.service.ts